import { Trans } from '@lingui/react/macro';

import { Text } from '@/components/typography';

type Props = {
  isLoggingOut?: boolean;
};

const GlobalLoader = ({ isLoggingOut }: Props) => {
  return (
    <div className="pointer-events-none fixed top-0 left-0 z-99999 m-0 flex h-full w-full items-center justify-center bg-white p-0">
      <div className="relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="stroke-primary"
          width="204"
          height="204"
          viewBox="-19.25 -19.25 40.5 40.5"
        >
          <g fill="none" fillRule="evenodd">
            <g transform="translate(1 1)" strokeWidth="0.5">
              <circle className="stroke-opacity-0.5 stroke-white/30" cx="0" cy="0" r="20" />
              <path d="M20 0c0-9.94-8.06-20-20-20">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 0 0"
                  to="360 0 0"
                  dur="1s"
                  repeatCount="indefinite"
                ></animateTransform>
              </path>
            </g>
          </g>
        </svg>
        <div className="absolute top-20 left-[25px] w-[150px] text-center">
          <Text variant="subhead">
            {isLoggingOut ? (
              <Trans>Logging you out</Trans>
            ) : (
              <Trans>Loading up your C99 experience</Trans>
            )}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
